import React from 'react';
import { modules } from '../../data/curly';
export function ModulesSection() {
  return <section className="border-b border-white/5 bg-cocoa py-20" aria-labelledby="modules-title" data-id="element-73" data-mp="2sqvfld09vu3y">
      <div className="mx-auto w-full max-w-4xl px-6" data-id="element-74" data-mp="36hibyyik97wv">
        <h2 id="modules-title" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-75" data-mp="36gyufiwtoljd">
          Los seis pasos, en orden
        </h2>
        <p className="mt-4 max-w-prose text-sand" data-id="element-76" data-mp="2eqavmdimfs8v">
          El orden importa: saltarte el diagnóstico es la razón número uno por la que una rutina
          curly falla.
        </p>

        <ol className="mt-12 border-l border-white/10" data-id="element-77" data-mp="29tu5jdrv33t5">
          {modules.map(module => <li key={module.number} className="relative pb-10 pl-8 last:pb-0" data-id="element-78" data-mp="2nowcm48g2z7j">
              <span aria-hidden="true" className="absolute -left-[9px] top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border border-gold bg-ink" data-id="element-79" data-mp="2iqut5i73wxvj">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-80" data-mp="3u9p41lh96sqh" />
              </span>
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-81" data-mp="1dajbsflktnnk">
                <span className="font-display text-xl text-gold" data-id="element-82" data-mp="1h8h4hsek2rvp">{module.number}</span>
                <h3 className="font-display text-2xl text-cream" data-id="element-83" data-mp="1mag8n4i4dstp">{module.title}</h3>
                <span className="text-xs uppercase tracking-[0.18em] text-sand/70" data-id="element-84" data-mp="1r8hrbobmvq4n">
                  {module.duration}
                </span>
              </div>
              <p className="mt-2 max-w-prose text-sand" data-id="element-85" data-mp="yjk7vhvornab">{module.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}